export enum FillableDocumentType {
    W8BEN = 'W8BEN',
    W_9 = 'W_9',
    W_4 = "W_4",
    IT_2104 = 'IT_2104',
    F_8822_B = 'F_8822_B'
}